import React, { createContext, useContext, useState, useEffect } from "react";

const newBlockId = () =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `b-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

const PageContext = createContext();
export const usePage = () => useContext(PageContext);

export const PageProvider = ({ children }) => {
  const [blocks, setBlocks] = useState([]);
  const [mode, setMode] = useState("edit");

  useEffect(() => {
    const saved = localStorage.getItem("page");
    if (saved) setBlocks(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("page", JSON.stringify(blocks));
  }, [blocks]);

  const addBlock = (type) => {
    const newBlock = {
      id: newBlockId(),
      type,
      data: getDefaultData(type),
    };
    setBlocks((prev) => [...prev, newBlock]);
  };

  const updateBlock = (id, patch) => {
    setBlocks((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, data: { ...b.data, ...patch } } : b
      )
    );
  };

  const deleteBlock = (id) => {
    setBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <PageContext.Provider
      value={{ blocks, setBlocks, addBlock, updateBlock, deleteBlock, mode, setMode }}
    >
      {children}
    </PageContext.Provider>
  );
};

const getDefaultData = (type) => {
  switch (type) {
    case "text":
      return { text: "" };
    case "image":
      return { url: "" };
    case "header":
      return { text: "", level: 1 };
    case "markdown":
      return { text: "" };
    default:
      return {};
  }
};